module.exports = __webpack_public_path__ + "media/images/airport-grayscale-b09a2a63c933681415630f00bcdefad8.jpg";